import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';
import About from '../components/About';
import Guides from '../components/Guides';
import FAQ from '../components/FAQ';
import News from '../components/News';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Offers />
        <About />
        <Guides />
        <FAQ />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;

